import React, { createContext, useEffect, useLayoutEffect, useState } from "react";
import { SidebarSection } from "./quote/sidebar";
import { MainSection } from "./quote/mainSection";
import { AmountSection } from "./quote/amountSection";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import "./index.css";

import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modals from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";

const styleOne = {
  position: "absolute",
  top: "40%",
  left: "35%",
  transform: "translate(-50%, -50%)",
  width: 450,
  bgcolor: "background.paper",
  // border: '2px solid #000',
  borderRadius: "4px",
  boxShadow: 24,
  p: 4,
};

const styleTwo = {
  position: "absolute",
  top: "50%",
  left: "35%",
  transform: "translate(-5%, 25%)",
  width: 450,
  bgcolor: "background.paper",
  // border: '2px solid #000',
  borderRadius: "4px",
  boxShadow: 24,
  p: 4,
};

const styleThree = {
  position: "absolute",
  top: "20%",
  right: "35%",
  transform: "translate(30%, -50%)",
  width: 450,
  bgcolor: "background.paper",
  // border: '2px solid #000',
  borderRadius: "4px",
  boxShadow: 24,
  p: 4,
};

const styleFour = {
  position: "absolute",
  top: "40%",
  right: "35%",
  transform: "translate(30%, -50%)",
  width: 450,
  bgcolor: "background.paper",
  // border: '2px solid #000',
  borderRadius: "4px",
  boxShadow: 24,
  p: 4,
};

const styleFive = {
  position: "absolute",
  top: "60%",
  right: "35%",
  transform: "translate(30%, -50%)",
  width: 450,
  bgcolor: "background.paper",
  // border: '2px solid #000',
  borderRadius: "4px",
  boxShadow: 24,
  p: 4,
};

let sidebarData = [
  {
    id: 1,
    heading: "Printed Book Distribution",
    subHeading: "Selection required",
    projectType: "PrintedBooks",
  },
  {
    id: 2,
    heading: "Text Formatting",
    subHeading: "Selection required",
    projectType: "PrintedBooks",
  },
  {
    id: 3,
    heading: "Cover Design",
    subHeading: "Selection required",
    projectType: "PrintedBooks",
  },
  {
    id: 4,
    heading: "ISBN – Printed Books",
    subHeading: "Selection required",
    projectType: "PrintedBooks",
  },
  {
    id: 5,
    heading: "Images – Printend Books",
    subHeading: "Selection required",
    projectType: "PrintedBooks",
  },
  {
    id: 6,
    heading: "Printed Books File Conversion",
    subHeading: "Selection required",
    projectType: "PrintedBooks",
  },
  {
    id: 7,
    heading: "Recommended For You",
    subHeading: "Selection(s) optional",
    projectType: "PrintedBooks",
  },

  {
    id: 8,
    heading: "Save Project",
    subHeading: "Enter a quote name",
    projectType: "PrintedBooks",
  },
];

let ebookDistribution = [
  {
    id: 1,
    heading: "eBook Distribution",
    subHeading: "eBook Conversion (w/ Distribution)",
  },
  {
    id: 2,
    heading: "eBook Formatting",
    subHeading: "Selection required",
  },
  {
    id: 3,
    heading: "ebook Cover Design",
    subHeading: "I am supplying my eBook cover",
  },
  {
    id: 4,
    heading: "ISBN – eBooks",
    subHeading: "I already have an ISBN for my eBook",
  },
  {
    id: 5,
    heading: "eBook File Conversion",
    subHeading: "Selection required",
  },
  {
    id: 6,
    heading: "Images – eBooks",
    subHeading: "Selection required",
  },
  {
    id: 7,
    heading: "Recommended For You",
    subHeading: "Selection(s) optional",
  },
  {
    id: 8,
    heading: "Save Project",
    subHeading: "Enter a quote name",
  },
];
let eBookAndPrinted = [
  {
    id: 1,
    heading: "Printed Book Distribution",
    subHeading: "Selection required",
  },
  {
    id: 2,
    heading: "Text Formatting",
    subHeading: "Selection required",
  },
  {
    id: 3,
    heading: "Cover Design",
    subHeading: "Selection required",
  },
  {
    id: 4,
    heading: "ISBN – Printed Books",
    subHeading: "Selection required",
  },
  {
    id: 5,
    heading: "ISBN – eBooks",
    subHeading: "Selection required",
  },
  {
    id: 6,
    heading: "eBook File Conversion",
    subHeading: "Selection required",
  },
 
  {
    id: 7,
    heading: "Recommended For You",
    subHeading: "Selection(s) optional",
  },
  {
    id: 8,
    heading: "Save Project",
    subHeading: "Enter a quote name",
    projectType: "PrintedBooks",
  },
];

export const DataContext = createContext(null);
export const MainPage = () => {








  const [displayedSidebar, setDisplaySidebar] = useState(sidebarData); // Initially, show the first 6 images
  let [sidebarLink, setsidebarLink] = useState("ebookDistribution");
  let [amountValue, setAmountValue] = useState(99);
  const [completedSection, setCompletedSection] = useState(false);
  const [tourData, setTourData] = useState("");
  const [openMUI, setOpenMUI] = React.useState(false);
  const handleOpen = (datas) => {
    setTourData(datas);
    setOpenMUI(true);
  };
  const handleClose = () => setOpenMUI(false);

  let [summeryModel, setSummeryModel] = useState(false);
  let [infoModel, setInfoModel] = useState(false);
  let [tourModel, setTourModel] = useState(false);
  let [infoData, setInfoData] = useState("");
  const [count, setCount] = useState(0);
  let [selectValue, setSelectValue] = useState({
    section1: null,
    section2: null,
    section3: null,
    section4: null,
    section5: null,
    section6: null,
    section7: null,
    section8: null,
  });
  let [liData, setLiData] = useState(1);
  let [quantity, setQuantity] = useState({
    quantityAmount: 1,
    quantityPages: 24,
  });
  let [totalAmount, setTotalAmount] = useState({});



  // render Sidebar
  useLayoutEffect(() =>{
    const queryParams = new URLSearchParams(window.location.search);

    // Get the values of the specific parameters
    const projectType = queryParams.get('projectType');
    // const printedBooks = queryParams.get('printedbooks');

    if(projectType == "printedbooks"){
      setDisplaySidebar(sidebarData)
    }else if(projectType == "ebook"){
      setDisplaySidebar(ebookDistribution)
    }else if(projectType == "ebookandprinted"){
      setDisplaySidebar(eBookAndPrinted)
    }else{
      setDisplaySidebar(sidebarData)
    }

    // Log the parameter values
    console.log('Project Type:', projectType);
  },[]);






  const getLiData = (id) => {
    let filterData = ebookDistribution.filter((value) => value.id == id);
    console.log("filterData", filterData);
    setLiData(filterData[0].id);
  };
  console.log("selectValueselectValue", selectValue);
  const onChangeAllValue = (e) => {
    setSelectValue({ ...selectValue, section1: e.currentTarget.value });
  };
  const onSectionTwo = (e) => {
    setSelectValue({ ...selectValue, section2: e.currentTarget.value });
  };
  const onSectionThree = (e) => {
    setSelectValue({ ...selectValue, section3: e.currentTarget.value });
  };

  const onSectionFour = (e) => {
    setSelectValue({ ...selectValue, section4: e.currentTarget.value });
  };

  const onSectionFive = (e) => {
    setSelectValue({ ...selectValue, section5: e.currentTarget.value });
  };

  const onSectionSix = (e) => {
    setSelectValue({ ...selectValue, section6: e.currentTarget.value });
  };

  const onSectionSeven = (e) => {
    setSelectValue({ ...selectValue, section7: e.currentTarget.value });
  };
  const onSectionEight = (e) => {
    setSelectValue({ ...selectValue, section8: e.currentTarget.value });
  };

  const handleFilterKeyChange = (filter) => {
    // Depending on the active button, set the appropriate data array.
    switch (filter) {
      case "printedbooks":
        setDisplaySidebar(sidebarData);
        break;
      case "ebook":
        setDisplaySidebar(ebookDistribution);
        break;
      case "ebookandprinted":
        setDisplaySidebar(eBookAndPrinted);
        break;
      default:
        // Default to 'logo'
        setDisplaySidebar(sidebarData);
    }
  };

  let clickData = () => {
    handleFilterKeyChange("printedbooks");
  };

  useEffect(() => {
    if (
      selectValue.section1 != null ||
      selectValue.section2 !== null ||
      selectValue.section3 !== null ||
      selectValue.section4 !== null ||
      selectValue.section5 !== null ||
      selectValue.section6 !== null ||
      selectValue.section7 !== null
    ) {
      // Add the value of selectValue.section1 to amountValue
      // setAmountValue(prev => prev + Number(selectValue.section1));
      console.log("Nulling");
      setAmountValue((prev) => {
        let sum = 0;
        if (selectValue.section1 != null) {
          sum += Number(selectValue.section1);
        }
        if (selectValue.section2 != null) {
          sum += Number(selectValue.section2);
        }
        if (selectValue.section3 != null) {
          sum += Number(selectValue.section3);
        }
        if (selectValue.section4 != null) {
          sum += Number(selectValue.section4);
        }
        if (selectValue.section5 != null) {
          sum += Number(selectValue.section5);
        }
        if (selectValue.section6 != null) {
          sum += Number(selectValue.section6);
        }
        if (selectValue.section7 != null) {
          sum += Number(selectValue.section7);
        }
        return prev + sum;
      });
    }

    if (totalAmount.quantityAmount == 25) {
      // Add 113 to amountValue
      setAmountValue((prev) => prev + 113);
    }

    if (totalAmount.quantityAmount > 25) {
      // Calculate the additional amount to add based on the difference between quantityAmount and 25
      const additionalAmount = (totalAmount.quantityAmount - 25) * 9;

      // Add the default amount (113) plus the additional amount to amountValue
      setAmountValue((prev) => prev + 113 + additionalAmount);
    }

    // if (totalAmount.quantityPages > 100) {
    //   // Add 150 to amountValue
    //   setAmountValue(prev => prev + 150);
    // }

    if (totalAmount.quantityPages > 100) {
      // Calculate the additional amount to add based on the difference between quantityAmount and 25
      const additionalAmount = (totalAmount.quantityPages - 100) * 150;

      // Add the default amount (113) plus the additional amount to amountValue
      setAmountValue((prev) => prev + additionalAmount);
    }

    // Cleanup function
    return () => {
      // Check if selectValue.section1 is not null
      let subtractValue = 0;

      // Check if selectValue.section1 is not null
      if (selectValue.section1 !== null) {
        subtractValue += Number(selectValue.section1);
      }
      // Check if selectValue.selectOne is not null
      if (selectValue.section2 !== null) {
        subtractValue += Number(selectValue.section2);
      }
      // Check if selectValue.selectTwo is not null
      if (selectValue.section3 !== null) {
        subtractValue += Number(selectValue.section3);
      }
      if (selectValue.section4 !== null) {
        subtractValue += Number(selectValue.section4);
      }
      if (selectValue.section5 !== null) {
        subtractValue += Number(selectValue.section5);
      }
      if (selectValue.section6 !== null) {
        subtractValue += Number(selectValue.section6);
      }
      if (selectValue.section7 !== null) {
        subtractValue += Number(selectValue.section7);
      }

      // Subtract the calculated total from amountValue
      setAmountValue((prev) => prev - subtractValue);
      // if (selectValue.section1 !== null) {
      //   // Subtract the value of selectValue.section1 from amountValue
      //   setAmountValue(prev => prev - Number(selectValue.section1));
      // }

      if (totalAmount.quantityAmount == 25) {
        // Subtract 113 from amountValue
        setAmountValue((prev) => prev - 113);
      }
      if (totalAmount.quantityAmount > 25) {
        // Calculate the additional amount to subtract based on the difference between quantityAmount and 25
        const additionalAmount = (totalAmount.quantityAmount - 25) * 9;

        // Subtract the default amount (113) plus the additional amount from amountValue
        setAmountValue((prev) => prev - (113 + additionalAmount));
      }

      if (totalAmount.quantityPages > 25) {
        // Calculate the additional amount to subtract based on the difference between quantityAmount and 25
        const additionalAmount = (totalAmount.quantityPages - 100) * 150;

        // Subtract the default amount (113) plus the additional amount from amountValue
        setAmountValue((prev) => prev - additionalAmount);
      }
    };
  }, [
    selectValue.section1,
    selectValue.section2,
    selectValue.section3,
    selectValue.section4,
    selectValue.section5,
    selectValue.section6,
    selectValue.section7,
    quantity,
    totalAmount,
  ]);

  const [open, setOpen] = useState(false);

  const onOpenModal = (data) => {
    console.log("save Dtaa");
    if (data == "success") {
      setCompletedSection(true);
      setOpen(true);
    }
  };
  const onCloseModal = () => {
    setCompletedSection(false);
    setOpen(false);
  };

  let onOpenSummeryModal = () => {
    setSummeryModel(true);
  };
  let onCloseSummerModel = () => {
    setSummeryModel(false);
  };

  let onOpenDataModal = (data) => {
    setInfoData(data);
    setInfoModel(true);
  };
  let onCloseDataModel = () => {
    setInfoModel(false);
  };

  let onOpenTourModel = () => {
    setTourModel(true);
  };
  let onCloseTourModel = () => {
    setTourModel(false);
  };

  // handleFilterKeyChange("ebook");
  return (
    <DataContext.Provider
      value={{
        count,
        setCount,
        sidebarData,
        getLiData,
        liData,
        setSelectValue,
        selectValue,
        onChangeAllValue,
        onSectionTwo,
        onSectionThree,
        onSectionFour,
        onSectionFive,
        onSectionSix,
        displayedSidebar,
        clickData,
        amountValue,
        setQuantity,
        quantity,
        setTotalAmount,
        onOpenModal,
        onCloseModal,
        sidebarLink,
        onSectionSeven,
        onSectionEight,
        onOpenSummeryModal,
        setInfoData,
        onOpenDataModal,
        onOpenTourModel,
        handleOpen,
      }}
    >
      <div className="w-full flex justify-between">
        <SidebarSection />
        <MainSection />
        <AmountSection />
        {/* <button onClick={onOpenModal}>Open modal</button> */}
        {completedSection ? (
          <Modal open={open} onClose={onCloseModal} center>
            {/* <h2 className="text-black">Simple centered modal</h2> */}
            <div className="px-4 !text-black">
              <div className="flex flex-col gap-2">
                <h1 className="!text-black text-2xl text-center my-12">
                  The Data has been saved successfully
                </h1>
              </div>
            </div>
          </Modal>
        ) : (
          ""
        )}

        <div>
          <Modal
            open={summeryModel}
            onClose={onCloseSummerModel}
            center
            classNames={"second_model_section"}
          >
            {/* <h2 className="text-black">Simple centered modal</h2> */}
            <div className="px-4 !text-black">
              <div className="flex flex-col gap-2">
                <p className="!text-black">List of data</p>

                <div
                  className="flex justify-between items-center"
                  style={{ borderBottom: "1px solid lightgrey" }}
                >
                  <p className="text-sm">PROJECT TYPE</p>
                  <p className="text-sm">Printed Books & eBooks</p>
                </div>

                <div
                  className="flex justify-between items-center"
                  style={{ borderBottom: "1px solid lightgrey" }}
                >
                  <p className="text-sm">GENRE</p>
                  <p className="text-sm">Fiction, Non-Fiction, & Biography</p>
                </div>

                {selectValue.section1 != null ? (
                  <div
                    className="flex justify-between items-center cursor-pointer"
                    style={{ borderBottom: "1px solid lightgrey" }}
                    onClick={() => {
                      getLiData(1);
                      onCloseSummerModel();
                    }}
                  >
                    <p className="text-sm">eBook Distribution</p>
                    <p className="text-sm">
                      $
                      {selectValue.section1 &&
                        Number(selectValue?.section1).toFixed(2)}
                    </p>
                  </div>
                ) : (
                  ""
                )}
                {selectValue.section2 != null ? (
                  <div
                    className="flex justify-between items-center cursor-pointer"
                    style={{ borderBottom: "1px solid lightgrey" }}
                    onClick={() => {
                      getLiData(2);
                      onCloseSummerModel();
                    }}
                  >
                    <p className="text-sm">eBook Formatting</p>
                    <p className="text-sm">
                      $
                      {selectValue.section2 &&
                        Number(selectValue?.section2).toFixed(2)}
                    </p>
                  </div>
                ) : (
                  ""
                )}

                {selectValue.section3 != null ? (
                  <div
                    className="flex justify-between items-center cursor-pointer"
                    style={{ borderBottom: "1px solid lightgrey" }}
                    onClick={() => {
                      getLiData(3);
                      onCloseSummerModel();
                    }}
                  >
                    <p className="text-sm">eBook Cover Design</p>
                    <p className="text-sm">
                      $
                      {selectValue.section3 &&
                        Number(selectValue?.section3).toFixed(2)}
                    </p>
                  </div>
                ) : (
                  ""
                )}

                {selectValue.section4 != null ? (
                  <div
                    className="flex justify-between items-center cursor-pointer"
                    style={{ borderBottom: "1px solid lightgrey" }}
                    onClick={() => {
                      getLiData(4);
                      onCloseSummerModel();
                    }}
                  >
                    <p className="text-sm">ISBN - eBooks</p>
                    <p className="text-sm">
                      $
                      {selectValue.section4 &&
                        Number(selectValue?.section4).toFixed(2)}
                    </p>
                  </div>
                ) : (
                  ""
                )}

                {selectValue.section5 != null ? (
                  <div
                    className="flex justify-between items-center cursor-pointer"
                    style={{ borderBottom: "1px solid lightgrey" }}
                    onClick={() => {
                      getLiData(5);
                      onCloseSummerModel();
                    }}
                  >
                    <p className="text-sm">eBook File Conversion</p>
                    <p className="text-sm">
                      $
                      {selectValue.section5 &&
                        Number(selectValue?.section5).toFixed(2)}
                    </p>
                  </div>
                ) : (
                  ""
                )}

                {selectValue.section6 != null ? (
                  <div
                    className="flex justify-between items-center cursor-pointer"
                    style={{ borderBottom: "1px solid lightgrey" }}
                    onClick={() => {
                      getLiData(6);
                      onCloseSummerModel();
                    }}
                  >
                    <p className="text-sm">Images - eBooks</p>
                    <p className="text-sm">
                      $
                      {selectValue.section6 &&
                        Number(selectValue?.section6).toFixed(2)}
                    </p>
                  </div>
                ) : (
                  ""
                )}

                {selectValue.section7 != null ? (
                  <div
                    className="flex justify-between items-center cursor-pointer"
                    style={{ borderBottom: "1px solid lightgrey" }}
                    onClick={() => {
                      getLiData(7);
                      onCloseSummerModel();
                    }}
                  >
                    <p className="text-sm">Recommended For You</p>
                    <p className="text-sm">
                      $
                      {selectValue.section7 &&
                        Number(selectValue?.section7).toFixed(2)}
                    </p>
                  </div>
                ) : (
                  ""
                )}

                <div
                  className="flex justify-between items-center !text-2xl"
                  style={{ borderBottom: "1px solid lightgrey" }}
                >
                  <p className="text-sm">Initial Amount</p>
                  <p className="text-sm">$99.00</p>
                </div>

                <div className="flex justify-center gap-6">
                  <div className="w-full flex flex-col">
                    <div
                      className="flex justify-between items-center"
                      style={{ borderBottom: "1px solid lightgrey" }}
                    >
                      <p className="!text-sm">QUANTITY</p>
                      <p>{quantity.quantityAmount}</p>
                    </div>
                    <div
                      className="flex justify-between items-center"
                      style={{ borderBottom: "1px solid lightgrey" }}
                    >
                      <p className="!text-sm">Count Pages</p>
                      <p>{quantity.quantityPages}</p>
                    </div>
                    <div
                      className="flex justify-between items-center"
                      style={{ borderBottom: "1px solid lightgrey" }}
                    >
                      <p className="!text-sm">PRODUCTION TIME </p>
                      <p>Standard - 2 Days</p>
                    </div>
                  </div>

                  <div className="w-full flex flex-col gap-2">
                    <div
                      className="flex justify-between items-center !text-2xl"
                      style={{ borderBottom: "1px solid lightgrey" }}
                    >
                      <p className="!text-sm">EST. SHIP DATE</p>
                      <p>N/A</p>
                    </div>
                    <div
                      className="flex justify-between items-center !text-2xl"
                      style={{ borderBottom: "1px solid lightgrey" }}
                    >
                      <p className="!text-sm">PRICE (EXCL. TAX & SHIPPING)</p>
                      <p className="text-xl font-semibold">
                        ${amountValue && amountValue}.00
                      </p>
                    </div>
                  </div>
                </div>
                <div className="my-2 text-center underline">
                  <p>
                    Pay in 4 interest-free payments of $190.13 with PayPal{" "}
                    <span className="text-blue-400">Learn more</span>{" "}
                  </p>
                </div>
              </div>
            </div>
          </Modal>

          {infoData == "productionTime" ? (
            <Modal open={infoModel} onClose={onCloseDataModel} center>
              {/* <h2 className="text-black">Simple centered modal</h2> */}
              <div className="px-4 !text-black">
                <div className="flex flex-col gap-2">
                  <h1 className="!text-black text-2xl text-center">
                    Production Time
                  </h1>
                  <p>
                    The number of business days it will take to produce your
                    order after we receive all of your parts (design and
                    content). We use noon EST as a production deadline. So if we
                    have all parts BEFORE Noon on a business day (M-F), that
                    counts as Day 0 (zero). After noon, tomorrow counts as Day 0
                    (zero).
                  </p>
                  <p>
                    If you have a deadline please call to explore options to
                    meet your requirements.
                  </p>
                </div>
              </div>
            </Modal>
          ) : infoData == "estimateDate" ? (
            <Modal open={infoModel} onClose={onCloseDataModel} center>
              {/* <h2 className="text-black">Simple centered modal</h2> */}
              <div className="px-4 !text-black">
                <div className="flex flex-col gap-2">
                  <h1 className="!text-black text-2xl text-center ">
                    Estimated Ship Date
                  </h1>
                  <p>
                    The "Est. Ship Date" is only shown for printed book orders
                    that don’t require design services. The Estimated Ship Date
                    is the final day of production and does not include transit
                    time. Carrier deliveries are not guaranteed. Turn times are
                    quoted in business days. Major holidays and weekends are not
                    considered business days.
                  </p>
                  <p>
                    “N/A” is shown for all orders that include design, editing,
                    or eBook conversion because the time required to complete
                    these services varies from project to project and any
                    associated print production schedules are not set until all
                    design and conversion proofs are approved.
                  </p>
                </div>
              </div>
            </Modal>
          ) : (
            <Modal
              open={infoModel}
              onClose={onCloseDataModel}
              center
              className={"modal-section"}
            >
              {/* <h2 className="text-black">Simple centered modal</h2> */}
              <div className="px-4 !text-black">
                <div className="flex flex-col gap-2">
                  <h1 className="!text-black text-2xl text-center">
                    Payment Options
                  </h1>
                  <p>
                    All prices are listed in U.S. Dollars. We accept cash,
                    check, money order, VISA, Mastercard, Discover, American
                    Express, PayPal, and PayPal Credit.
                  </p>
                </div>
              </div>
            </Modal>
          )}
        </div>
        {tourData == "one" ? (
          <Modals
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={openMUI}
            // onClose={handleClose}
            closeAfterTransition
            slots={{ backdrop: Backdrop }}
            slotProps={{
              backdrop: {
                timeout: 500,
              },
            }}
          >
            <Fade in={openMUI} className="relative">
              <Box sx={styleOne}>
                <div class="arrow-left absolute -left-4 top-20"></div>

                <Typography
                  id="transition-modal-title"
                  className="text-slate-950"
                  variant="h6"
                  component="h2"
                >
                  Steps 1/5
                </Typography>
                <Typography id="transition-modal-description" sx={{ mt: 2 }}>
                  This navigation menu lists the step names and selected quote
                  option(s) and can be used to navigate around the steps easily.
                </Typography>

                <Typography id="transition-modal-description" sx={{ mt: 2 }}>
                  Steps requiring a selection will display "Selection required"
                  and a selection is required before moving forward.
                </Typography>

                <div className="flex justify-between items-center my-4">
                  <button
                    type="button"
                    onClick={handleClose}
                    style={{ border: "1px solid #c65300" }}
                    className="btn themeBtn !w-32 !rounded-md !bg-white  !text-[#c65300]"
                  >
                    Skip
                  </button>
                  <button
                    type="button"
                    class="btn themeBtn !w-32 !rounded-md"
                    onClick={() => handleOpen("two")}
                  >
                    Next
                  </button>
                </div>
              </Box>
            </Fade>
          </Modals>
        ) : tourData == "two" ? (
          <Modals
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={openMUI}
            // onClose={handleClose}
            closeAfterTransition
            slots={{ backdrop: Backdrop }}
            slotProps={{
              backdrop: {
                timeout: 500,
              },
            }}
          >
            <Fade in={openMUI} className="relative">
              <Box sx={styleTwo}>
                <Typography
                  id="transition-modal-title"
                  className="text-slate-950"
                  variant="h6"
                  component="h2"
                >
                  Steps 2/5
                </Typography>
                <div class="arrow-down absolute left-52 -bottom-5"></div>
                <Typography id="transition-modal-description" sx={{ mt: 2 }}>
                  Use these buttons to navigate through the quote steps one at a
                  time. The left and right arrows keys can also be used to
                  navigate through the steps.
                </Typography>

                <div className="flex justify-between items-center my-4">
                  <button
                    type="button"
                    onClick={() => handleOpen("one")}
                    style={{ border: "1px solid #c65300" }}
                    className="btn themeBtn !w-32 !rounded-md !bg-white  !text-[#c65300]"
                  >
                    Back
                  </button>
                  <button
                    type="button"
                    class="btn themeBtn !w-32 !rounded-md"
                    onClick={() => handleOpen("three")}
                  >
                    Next
                  </button>
                </div>
              </Box>
            </Fade>
          </Modals>
        ) : tourData == "three" ? (
          <Modals
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={openMUI}
            // onClose={handleClose}
            closeAfterTransition
            slots={{ backdrop: Backdrop }}
            slotProps={{
              backdrop: {
                timeout: 500,
              },
            }}
          >
            <Fade in={openMUI} className="relative">
              <Box sx={styleThree}>
                <div class="arrow-right absolute -right-4 top-20"></div>

                <Typography
                  id="transition-modal-title"
                  className="text-slate-950"
                  variant="h6"
                  component="h2"
                >
                  Steps 3/5
                </Typography>
                <Typography id="transition-modal-description" sx={{ mt: 2 }}>
                  Configure the options of the quote in this section.
                </Typography>

                <Typography id="transition-modal-description" sx={{ mt: 2 }}>
                  When these options are updated the estimated ship date (if
                  applicable) and quote price may also be updated.
                </Typography>
                <div className="flex justify-between items-center my-4">
                  <button
                    type="button"
                    onClick={() => handleOpen("two")}
                    style={{ border: "1px solid #c65300" }}
                    className="btn themeBtn !w-32 !rounded-md !bg-white  !text-[#c65300]"
                  >
                    Back
                  </button>
                  <button
                    type="button"
                    class="btn themeBtn !w-32 !rounded-md"
                    onClick={() => handleOpen("four")}
                  >
                    Next
                  </button>
                </div>
                {/* <button onClick={() => handleOpen("four")}>Next</button> */}
              </Box>
            </Fade>
          </Modals>
        ) : tourData == "four" ? (
          <Modals
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={openMUI}
            // onClose={handleClose}
            closeAfterTransition
            slots={{ backdrop: Backdrop }}
            slotProps={{
              backdrop: {
                timeout: 500,
              },
            }}
          >
            <Fade in={openMUI} className="relative">
              <Box sx={styleFour}>
                <div class="arrow-right absolute -right-4 top-20"></div>

                <Typography
                  id="transition-modal-title"
                  className="text-slate-950"
                  variant="h6"
                  component="h2"
                >
                  Project Details 4/5
                </Typography>
                <Typography id="transition-modal-description" sx={{ mt: 2 }}>
                  Click on the "Get a new quote" link to change the project type
                  and/or genre and configure a new quote.
                </Typography>
                <div className="flex justify-between items-center my-4">
                  <button
                    type="button"
                    onClick={() => handleOpen("three")}
                    style={{ border: "1px solid #c65300" }}
                    className="btn themeBtn !w-32 !rounded-md !bg-white  !text-[#c65300]"
                  >
                    Back
                  </button>
                  <button
                    type="button"
                    class="btn themeBtn !w-32 !rounded-md"
                    onClick={() => handleOpen("five")}
                  >
                    Next
                  </button>
                </div>
                {/* <button onClick={() => handleOpen("five")}>Next</button> */}
              </Box>
            </Fade>
          </Modals>
        ) : (
          <Modals
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={openMUI}
            // onClose={handleClose}
            closeAfterTransition
            slots={{ backdrop: Backdrop }}
            slotProps={{
              backdrop: {
                timeout: 500,
              },
            }}
          >
            <Fade in={openMUI} className="relative">
              <Box sx={styleFive}>
                <div class="arrow-right absolute -right-4 top-20"></div>

                <Typography
                  id="transition-modal-title"
                  className="text-slate-950"
                  variant="h6"
                  component="h2"
                >
                  Quote Details 5/5
                </Typography>
                <Typography id="transition-modal-description" sx={{ mt: 2 }}>
                  Here you will find the quote's subtotal, shipping cost, and
                  estimated ship date (if applicable). These values will update
                  whenever a new choice is made.
                </Typography>
                <Typography id="transition-modal-description" sx={{ mt: 2 }}>
                  Click on the "View summary" link to view the full details of
                  the quote. There's also an option to print the quote.
                </Typography>

                {/* <button onClick={handleClose}>Close</button> */}
                <div className="flex justify-between items-center my-4">
                  <button
                    type="button"
                    onClick={() => handleOpen("four")}
                    style={{ border: "1px solid #c65300" }}
                    className="btn themeBtn !w-32 !rounded-md !bg-white  !text-[#c65300]"
                  >
                    Back
                  </button>
                  <button
                    type="button"
                    class="btn themeBtn !w-32 !rounded-md"
                    onClick={handleClose}
                  >
                    Close
                  </button>
                </div>
              </Box>
            </Fade>
          </Modals>
        )}
        {/* <button class="jerk-button">Click Me</button> */}
      </div>
    </DataContext.Provider>
  );
};
